var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.432 1.104c.18.18.36.54.36.81L11.79 5l4.947 3.298c.27.18.36.45.36.72l-.001 8.183h.99c.54 0 .9.36.9.9s-.36.899-.9.899H1.899C1.36 19 1 18.64 1 18.1c0-.539.36-.899.9-.899h.898V5.511c0-.36.18-.63.54-.81l7.195-3.597c.27-.18.63-.09.899 0zm.359 6.076v10.021h3.597V9.557L11.792 7.18zM9.993 3.352 4.597 6.05v11.151h5.396V5.819a.91.91 0 0 1 0-.66V3.352zM7.295 14.49c.54 0 .9.36.9.899 0 .54-.36.9-.9.9s-.9-.36-.9-.9.36-.9.9-.9zm0-3.415c.54 0 .9.36.9.9 0 .539-.36.899-.9.899s-.9-.36-.9-.9.36-.899.9-.899zm0-3.4c.54 0 .9.36.9.899 0 .54-.36.899-.9.899s-.9-.36-.9-.9c0-.539.36-.899.9-.899z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.50da61c02f83322dde960ee5035846bd.svg";
export { ForwardRef as ReactComponent };